import React from 'react';
import { Paper, Box, Typography, Divider } from '@mui/material';

const PersonalPension = ({ personalPension, salary, config }) => {
  // Only show if personalPension exists and the net contribution is > 0.
  if (!personalPension || Number(personalPension.netContribution) <= 0) {
    return null;
  }

  const { grossContribution, netContribution, estimatedRebate } = personalPension;

  // Assume a default configuration for 2025.
  const defaultPA = config.PERSONAL_ALLOWANCE;
  // Determine if the user is paying tax (i.e. salary exceeds the full personal allowance).
  const isPayingTax = salary > defaultPA;

  // If paying tax, basic rate relief applies and the gross contribution is net * 1.25.
  // If not paying tax, no relief applies so gross equals net.
  const effectiveGrossContribution = isPayingTax ? grossContribution : netContribution;
  const hasTopUp = isPayingTax && effectiveGrossContribution > netContribution;

  return (
    <Paper
      sx={{
        p: 3,
        mt: 2,
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: 2,
        boxShadow: 1,
        backgroundColor: 'background.paper'
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        Personal Pension Contribution
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1">
          You have contributed <strong>£{Number(netContribution).toLocaleString()}</strong> from your pocket to your personal pension.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1">
          Although these contributions are paid directly by you and are not deducted from your salary, this calculator reflects their impact on your overall tax liabilities. Your take home pay is shown before this pension contribution is made.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        {hasTopUp ? (
          <Typography variant="body1">
            Your pension provider boosts your contribution at the basic rate. For your net contribution of <strong>£{Number(netContribution).toLocaleString()}</strong>, the gross contribution becomes <strong>£{Number(effectiveGrossContribution).toLocaleString()}</strong>.
          </Typography>
        ) : (
          <Typography variant="body1">
            Since you are not paying tax, no basic rate tax relief applies. Your contribution remains at <strong>£{Number(netContribution).toLocaleString()}</strong>.
          </Typography>
        )}
      </Box>
      <Box>
        <Typography variant="body1">
        {isPayingTax ? (
            estimatedRebate > 0 ? (
              <>Additionally, you may claim an estimated rebate from HMRC of <strong>£{Number(estimatedRebate).toLocaleString()}</strong> for additional tax relief.</>
            ) : (
              <>No additional HMRC rebate is available as you are not paying higher rate tax.</>
            )
          ) : (
            <>No HMRC rebate is available as you are not paying tax.</>
          )}
        </Typography>
      </Box>
    </Paper>
  );
};

export default PersonalPension;
